import { render, staticRenderFns } from "./SuperPage.vue?vue&type=template&id=55b7faf0&scoped=true"
import script from "./SuperPage.vue?vue&type=script&lang=js"
export * from "./SuperPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b7faf0",
  null
  
)

export default component.exports